export interface SimplePaymentRetrieve {
    id: string
    status: string
    wallexRef: string
    failureReason: string
    paymentChannel: string
}

export interface SimplePaymentStatus {
    value: string
    description: string
    needReason: boolean
    available: string[]
}

export default class SimplePayment {
    static statuses(simplePayment: SimplePaymentRetrieve): SimplePaymentStatus[] {
        const statuses: Array<SimplePaymentStatus> = [
            {
                value: 'awaiting_funds',
                description: 'Awaiting Funds',
                needReason: false,
                available: [],
            },
            {
                value: 'processing',
                description: 'Processing',
                needReason: false,
                available: ['awaiting_funds'],
            },
            {
                value: 'completed',
                description: 'Completed',
                needReason: false,
                available: ['processing'],
            },
            {
                value: 'rejected',
                description: 'Rejected',
                needReason: true,
                available: ['awaiting_funds', 'processing'],
            },
            {
                value: 'failed',
                description: 'Failed',
                needReason: true,
                available: ['completed'],
            },
        ]

        const disableStatusChangeInternalPaymentChannel = ['completed', 'rejected']
        return statuses
            .filter((status) => status.available.includes(simplePayment.status) || simplePayment.status === status.value)
            .filter((status) =>
                simplePayment.paymentChannel === 'INTERNAL' && simplePayment.status === 'processing' ? !disableStatusChangeInternalPaymentChannel.includes(status.value) : true
            )
    }
}
